import { render, staticRenderFns } from "./ArchivesOverview.vue?vue&type=template&id=37076b2e&"
import script from "./ArchivesOverview.vue?vue&type=script&lang=js&"
export * from "./ArchivesOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports